module.exports = __webpack_public_path__ + "img/icon-dangerous-goods.f7db28c3.svg";